var _path, _path2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptyTransactions(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 55,
    viewBox: "0 0 58 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.9788 40.3509C34.7821 40.3509 41.108 34.0251 41.108 26.2217C41.108 18.4184 34.7821 12.0926 26.9788 12.0926C19.1755 12.0926 12.8496 18.4184 12.8496 26.2217C12.8496 34.0251 19.1755 40.3509 26.9788 40.3509ZM27.4216 20.389C27.4216 19.7486 26.9025 19.2295 26.2621 19.2295C25.6216 19.2295 25.1025 19.7486 25.1025 20.389V27.5248C25.1025 27.964 25.3506 28.3655 25.7435 28.562L30.3818 30.8811C30.9546 31.1675 31.6511 30.9353 31.9375 30.3625C32.2239 29.7897 31.9917 29.0932 31.4189 28.8068L27.4216 26.8082V20.389Z",
    fill: "url(#paint0_linear_2276_20513)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9793 2C31.7698 2 36.4528 3.42056 40.436 6.08205C44.4192 8.74354 47.5237 12.5264 49.357 16.9523C51.1903 21.3782 51.6699 26.2483 50.7353 30.9468C49.8008 35.6453 47.4939 39.9612 44.1064 43.3486C40.719 46.7361 36.4032 49.0429 31.7047 49.9775C27.0062 50.9121 22.136 50.4324 17.7101 48.5992C13.2842 46.7659 9.50137 43.6614 6.83988 39.6782C4.17839 35.695 2.75783 31.012 2.75783 26.2215C2.75015 19.2828 5.41977 12.6088 10.2106 7.58957M2.75781 9.45435L10.2106 7.59116L12.0738 15.0439",
    stroke: "url(#paint1_linear_2276_20513)",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_2276_20513)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.6192 33.8136C40.8031 33.8136 35.9961 38.3866 35.9961 44.1395C35.9961 49.8925 40.8031 54.4655 46.6192 54.4655C52.4352 54.4655 57.2422 49.8925 57.2422 44.1395C57.2422 38.3866 52.4352 33.8136 46.6192 33.8136ZM46.6192 35.4136C41.6359 35.4136 37.5961 39.3203 37.5961 44.1395C37.5961 48.9587 41.6359 52.8655 46.6192 52.8655C51.6025 52.8655 55.6422 48.9587 55.6422 44.1395C55.6422 39.3203 51.6025 35.4136 46.6192 35.4136ZM46.6198 36.2882C42.1348 36.2882 38.499 39.8043 38.499 44.1416C38.499 48.4789 42.1348 51.9949 46.6198 51.9949C51.1047 51.9949 54.7405 48.4789 54.7405 44.1416C54.7405 39.8043 51.1047 36.2882 46.6198 36.2882Z",
    fill: "white",
    fillOpacity: 0.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_2276_20513",
    x: 11.9961,
    y: 9.81356,
    width: 69.2461,
    height: 68.6519,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2276_20513"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_2276_20513",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2276_20513",
    x1: 19.6611,
    y1: 13.6787,
    x2: 38.854,
    y2: 45.167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D354FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CA30FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CA30FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2276_20513",
    x1: 42.863,
    y1: -21.4809,
    x2: 6.08225,
    y2: -15.816,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D354FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CA30FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CA30FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyTransactions);
export default __webpack_public_path__ + "static/media/empty-transactions.2b5e4c678c398fdb2c1e4dde9e814cd6.svg";
export { ForwardRef as ReactComponent };